import React from "react";
import style from "./Account.module.scss";
import { FormattedNumber } from "../../../../FormattedNumber/FormattedNumber";

const Balance = ({ balance }) => {
  return (
    <div className={style.balance}>
      {balance.map(
        (item, index) =>
          item.key !== "" && (
            <div key={`bitem-${index}`} className={style.item}>
              <span>{item.key}</span>
              <FormattedNumber value={item.value} dataTypeDecimalName="currency" />
            </div>
          )
      )}
    </div>
  );
};

export default Balance;
